<script setup lang="ts">
import AppToast from '@/components/AppToast.vue'
import ErrorBoundary from '@/components/ErrorBoundary.vue'
import { NConfigProvider } from '@/components/naive'
import { naiveDateLocale, naiveLocale } from '@/config/naive-locale'
import { xuntuThemeOverrides } from '@/config/naive-theme'
</script>

<template>
  <NConfigProvider
    :theme-overrides="xuntuThemeOverrides"
    :locale="naiveLocale"
    :date-locale="naiveDateLocale"
  >
    <ErrorBoundary>
      <RouterView />
    </ErrorBoundary>
    <AppToast />
  </NConfigProvider>
</template>
